export const PRODUCT_TASK_STORY_TASK_MUST_BE_CREATED_IN_BACKLOG_TOOLTIP =
  'Crea historias y tareas desde el backlog para que el Product Manager revise el valor y la viabilidad.';

export const PRODUCT_TASK_STORY_TASK_PUBLISH_REQUIRES_PM_TOOLTIP =
  'Solo el Product Manager puede marcar historias y tareas como preparadas.';
